import { render, staticRenderFns } from "./RegChagasAdd.vue?vue&type=template&id=43aa815b&scoped=true"
import script from "./RegChagasAdd.vue?vue&type=script&lang=js"
export * from "./RegChagasAdd.vue?vue&type=script&lang=js"
import style0 from "./RegChagasAdd.vue?vue&type=style&index=0&id=43aa815b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa815b",
  null
  
)

export default component.exports